import React, { useContext, useEffect, useState } from "react";

import SummaryTable from "./SummaryTable";
import BarChart from "./BarChart";
import PayeeOverlay from "./PayeeOverlay";
import RefreshContext from "../RefreshContext";
import PieChart from "./PieChart";
import Dollars from "./Dollars";
import withParams from "../lib/withParams";
import ColumnHeader from "./ColumnHeader";
import apiClient from "../lib/apiClient";

export default function Category({ id, name, dataViewId, accountId, onClose }) {
  const [payeeData, setPayeeData] = useState(null);
  const [payee, setPayee] = useState(null);
  const { refreshKey } = useContext(RefreshContext);
  const chartPath = withParams(`/api/categories/${id}/time_series_chart`, { dataViewId, accountId });

  // if the category is null, then we are looking at the "uncategorized" category
  name ||= 'Uncategorized';

  useEffect(() => {
    const fetchCategory = async () => {
      const url = withParams("/api/categories/" + id, { dataViewId, accountId });
      const { data } = await apiClient.get(url);

      setPayeeData(data);

    };
    fetchCategory();
  }, [id, refreshKey, dataViewId, accountId]);

  useEffect(() => {
    // if we have a selected payee, update it to use the latest payee data
    // (note this might end up setting the payee to null if the update resulted
    // in this payee not being part of the category anymore.
    if (payee && payeeData) {
      const newPayee = payeeData.payees.find(p => p.id === payee.id);
      setPayee(newPayee);
    }
  }, [payee, payeeData]);

  // if the user clicks on a different category at the top of the
  // nav, then we need to reset the payee to null.
  useEffect(() => {
    if (payee?.category !== name) {
      setPayee(null);
    }
  }, [name, payee, refreshKey]);

  if (!payeeData) return ""
  const { payees } = payeeData;
  return (
    <div className="">

      <div className="row">
        <ColumnHeader onClose={onClose} title={name} />
        <p>
          {payeeData.count} transactions totaling <Dollars amount={payeeData.total} /> or
          <Dollars amount={payeeData.total_per_month} /> per month.
        </p>
        <div className="row">
          <div className={"col-md-6 col-12"}>
            <BarChart title="Cashflow Trend" path={chartPath} />
          </div>
          <div className={"col-md-6 col-12"}>
            <PieChart title="Cashflow by Payee" data={payees} value="total_amount" label="name" />
          </div>
        </div>
      </div>

      <hr />
      <SummaryTable
        rows={payees}
        onRowClick={payee => {
          setPayee(payee)
        }}
        collapseAfter={8}
        selectedRow={payee}
        columns={[
          { title: "Payee", value: "name" },
          { title: "Count", value: "transaction_count" },
          { title: "Total", value: "total_amount", type: "currency" }
        ]} />
      <PayeeOverlay payee={payee} dataViewId={dataViewId} accountId={accountId} onClose={() => setPayee(null)} />
    </div>
  );
}
